export default __webpack_public_path__ + "static/media/Imani_Missouri_AHV_In_Moms_We_Trust.505d1e03.jpg";